/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AcceptAutoShipChurnPreventionOfferMutationVariables = Types.Exact<{
  input: Types.AcceptAutoShipChurnPreventionOfferInput;
}>;

export type AcceptAutoShipChurnPreventionOfferMutation = {
  __typename?: "Mutation";
  acceptAutoShipChurnPreventionOffer?: {
    __typename?: "AcceptAutoShipChurnPreventionOfferPayload";
    result:
      | {
          __typename?: "AcceptAutoShipChurnPreventionOfferError";
          code: Types.AcceptAutoShipChurnPreventionOfferErrorCode;
          message?: string | null;
        }
      | { __typename?: "AcceptAutoShipChurnPreventionOfferSuccess" };
  } | null;
};

export const AcceptAutoShipChurnPreventionOfferDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AcceptAutoShipChurnPreventionOffer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AcceptAutoShipChurnPreventionOfferInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptAutoShipChurnPreventionOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AcceptAutoShipChurnPreventionOfferError" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            { kind: "Field", name: { kind: "Name", value: "message" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AcceptAutoShipChurnPreventionOfferMutationFn = Apollo.MutationFunction<
  AcceptAutoShipChurnPreventionOfferMutation,
  AcceptAutoShipChurnPreventionOfferMutationVariables
>;

/**
 * __useAcceptAutoShipChurnPreventionOfferMutation__
 *
 * To run a mutation, you first call `useAcceptAutoShipChurnPreventionOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAutoShipChurnPreventionOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAutoShipChurnPreventionOfferMutation, { data, loading, error }] = useAcceptAutoShipChurnPreventionOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptAutoShipChurnPreventionOfferMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptAutoShipChurnPreventionOfferMutation,
    AcceptAutoShipChurnPreventionOfferMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptAutoShipChurnPreventionOfferMutation,
    AcceptAutoShipChurnPreventionOfferMutationVariables
  >(AcceptAutoShipChurnPreventionOfferDocument, options);
}
export type AcceptAutoShipChurnPreventionOfferMutationHookResult = ReturnType<
  typeof useAcceptAutoShipChurnPreventionOfferMutation
>;
export type AcceptAutoShipChurnPreventionOfferMutationResult =
  Apollo.MutationResult<AcceptAutoShipChurnPreventionOfferMutation>;
export type AcceptAutoShipChurnPreventionOfferMutationOptions = Apollo.BaseMutationOptions<
  AcceptAutoShipChurnPreventionOfferMutation,
  AcceptAutoShipChurnPreventionOfferMutationVariables
>;
